import { render } from "./UsersPage.vue?vue&type=template&id=0dc1a667&ts=true"
import script from "./UsersPage.ts?vue&type=script&lang=ts&external"
export * from "./UsersPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__